import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { LoginService } from '../login.service';

export const dashboardGuard: CanActivateFn = () => {
  const loginService = inject(LoginService);
  const router = inject(Router);

  if (!loginService.username) {
    return router.createUrlTree(['/']);
  }

  return loginService.premissionsReady.pipe(
    take(1),
    map((premissions) => (premissions?.Dashboard ? true : router.createUrlTree(['/patsearch'])))
  );
};
